export const MandatoryIndicator = () => (
  <span className="text-indigo-400 text-base font-semibold">{` *`}</span>
);
